export { default as MultiSelect } from './multi-select';
export type { Value } from './multi-select.types';
